import { render, staticRenderFns } from "./MyClassroomsPage.vue?vue&type=template&id=400dd141&scoped=true"
import script from "./MyClassroomsPage.vue?vue&type=script&lang=js"
export * from "./MyClassroomsPage.vue?vue&type=script&lang=js"
import style0 from "./MyClassroomsPage.vue?vue&type=style&index=0&id=400dd141&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400dd141",
  null
  
)

export default component.exports